import { z } from 'zod';
import { USER_GROUP_CONSTRAINTS } from './constraints.js';
export const updateUserGroupInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${USER_GROUP_CONSTRAINTS.name.label} cannot be empty.`)
        .max(USER_GROUP_CONSTRAINTS.name.maxLength)
        .optional(),
    description: z.string().max(USER_GROUP_CONSTRAINTS.description.maxLength).optional().nullable(),
});
//# sourceMappingURL=update-input.js.map